import { StateCreator } from 'zustand';

import { createAppStore } from '../zustand';
import { UserDetailsGlobalStoreType, UserDetailsGlobalStoreDataType } from './userDetailsGlobalStore.types';

export const userDetailsGlobalStoreIntitalState: UserDetailsGlobalStoreDataType = {
  rememberedUser: false,
  isUserDetailsSaved: false,
};

const userDetailsGlobalStore: StateCreator<UserDetailsGlobalStoreType> = set => {
  return {
    ...userDetailsGlobalStoreIntitalState,
    isSignedInUser: false,

    setUserInfo: (value?: Partial<UserDetailsGlobalStoreDataType>, isSignedInUser = false) => {
      set({ ...value, isSignedInUser });
    },

    setPartialUserInfo: (data: UserDetailsGlobalStoreDataType) => {
      set(prev => {
        return {
          ...prev,
          ...data,
        };
      });
    },

    resetUserInfo: () => {
      set({ ...userDetailsGlobalStoreIntitalState });
    },
  };
};

export const useUserDetailsGlobalStore = createAppStore(userDetailsGlobalStore, {
  usePersistentStore: true,
  persistentStoreName: 'UserDetailsGlobalStore',
});
